<div [ngSwitch]="filedInfo.textFieldType">
  <div class="form-group" *ngSwitchCase="'NATIONAL_CODE'">
    <input class="form-control"
           [class.form-error]="formControls.codeMelli.errors"
           type="tel" formControlName="filedInfo.key"
           autocomplete="off" [maxlength]="filedInfo.maxLength" [minlength]="filedInfo.minLength"
           required>
    <span class="floating-label">{{filedInfo.title}}</span>
    <span class="star">*</span>
    <span *ngIf="formControls.firstName.errors" class="errorInput">پر کردن این فیلد الزامی است.</span>
  </div>
</div>
